export default __webpack_public_path__ + "static/media/swagger.4982b16c.png";